import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconBrightness: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBrightness"><Circle cx="12" cy="12" r="5.5" stroke="currentColor"/><Path d="M12 1.5V2.5M12 21.5V22.5M4.5754 4.57538L5.31786 5.31784M18.6822 18.6822L19.4246 19.4246M19.4247 4.5754L18.6822 5.31786M5.31789 18.6822L4.57543 19.4246M1.5 12H2.5M21.5 12H22.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBrightness;
